import axios from './axios.service';
export default class Configs {
  /**
   * @param {Object} contestData an object that contains all config data
   */
  static saveContest(contestData) {
    return axios.put(`/api/v3/cmt-backend/configs/contest`, contestData);
  }

  static getContest() {
    return axios.get(`/api/v3/cmt-backend/configs/contest`);
  }

  static saveAffiliateBanners(banners) {
    return axios.put(`/api/v3/cmt-backend/configs/banners`, banners);
  }

  static getAffiliateBanners() {
    return axios.get(`/api/v3/cmt-backend/configs/banners`);
  }

  /** Get feature flags to enable or disable functionalities for CMT Frontend **/
  static getFeatureFlags() {
    return axios.get(`/api/v3/cmt-backend/configs/feature-flags`);
  }
}
